import styles from "./ChangePassword.module.scss";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import useAppSelector from "../../../../hooks/useAppSelector";
import { Form } from "antd";
import FormItemInputPassword from "../../../../components/ui/FormItemInputPassword/FormItemInputPassword";
import CustomButton from "../../../../components/ui/CustomButton/CustomButton";
import { IChangePasswordModel } from "../../../../models/User";
import { passwordValidation } from "../../../../helper/auth";
import { firstLetterToUpperCase, getLanguageFromLocal } from "../../../../helper/language";
import { openErrorMessage, openSuccessMessage } from "../../../../store/message/messageSlice";
import useAppDispatch from "../../../../hooks/useAppDispatch";
import { useUserMutations } from "../../../../api/mutations";
import { handleError } from "../../../../helper/errorHandler";

const ChangePassword = () => {
  const { t } = useTranslation();
  const { user } = useAppSelector((state) => state.userProfileSlice);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { changePassword } = useUserMutations();

  const onFinish = async (values: IChangePasswordModel) => {
    if (!user) return;

    const model = {
      oldPassword: values.oldPassword.trim(),
      newPassword: values.newPassword.trim(),
      confirmNewPassword: values.confirmNewPassword.trim(),
      lang: getLanguageFromLocal(),
    } as IChangePasswordModel;

    if (values.oldPassword === values.newPassword) {
      dispatch(openErrorMessage(t("EQUAL_OLD_PASSWORD")));
      return;
    }

    if (values.confirmNewPassword !== values.newPassword) {
      dispatch(openErrorMessage(t("PASSWORDS_ARE_NOT_EQUAL")));
      return;
    }

    if (!passwordValidation(values.newPassword)) {
      dispatch(openErrorMessage(t("ValidationPassword")));
      return;
    }

    changePassword(
      {
        id: user?.id || null,
        ...model,
      },
      {
        onSuccess: () => {
          dispatch(openSuccessMessage(t("PasswordChangedSuccessfully")));
          navigate(
            `/success?title=${t("PasswordSuccessfullyChanged")}&description=${t("YourPasswordForClubPassUpdatedSuccessfully")}&linkPath=/gyms-location&linkText=${t("BackToClasses")}`
          );
        },
        onError: (e) => handleError(e, dispatch, t),
      }
    );
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{firstLetterToUpperCase(t("ChangePassword"))}</h2>
      <Form className={styles.form} name="change-password" onFinish={onFinish} layout={"vertical"}>
        <FormItemInputPassword
          isSettings={true}
          name={"oldPassword"}
          label={t("OldPassword")}
          rules={{ required: true }}
        />

        <FormItemInputPassword
          isSettings={true}
          name={"newPassword"}
          label={t("NewPassword")}
          rules={{ required: true }}
        />

        <FormItemInputPassword
          isSettings={true}
          name={"confirmNewPassword"}
          label={t("ConfirmNewPassword")}
          rules={{ required: true }}
        />

        <div className={styles.btnWrapper}>
          <CustomButton text={t("SaveChanges")} type={"submit"} typeStyle={"fill"} />
        </div>
      </Form>
      <p className={styles.text}>
        {t("DontRememberYourPassword")}{" "}
        <Link to={"/forgot-password"}>{t("ResetYourPasswordHere")}</Link>
      </p>
    </div>
  );
};

export default ChangePassword;
